import React from 'react';
import { useState } from 'react';

function Home() {
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [
    "/rec_sun.png",
    "/rec_snake.png",
    "/your_mother.png",
    "/retro_rec.png",
    "/rec_block.png",
    "/reco.png"
  ];

  return (
    <>
      <div className="card-grid">
        {images.map((src, index) => (
          <div key={index} className="card" onClick={() => setSelectedImage(src)}>
            <img src={src} alt={`Preview ${index}`} />
          </div>
        ))}
      </div>

      {selectedImage && (
        <div className="modal" onClick={() => setSelectedImage(null)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <img src={selectedImage} alt="Full preview" />
            <button className="close-button" onClick={() => setSelectedImage(null)}>×</button>
          </div>
        </div>
      )}
    </>
  );
}

export default Home;
